import React, { useState } from "react";
import styles from "./Pause.module.scss";
import PauseIcon from "components/UI/Icons/Sidecar/Pause";
import DeleteIcon from "components/UI/Icons/Delete";
import EditIcon from "components/UI/Icons/Lines/Edit";
import { useDispatch } from "react-redux";
import { removeSidecarConfigNewTempActionList, setShowPauseDialogue } from "redux/sidecar/sidecarSlice";
import MoveUpDown from "components/UI/Icons/Sidecar/MoveUpDown";

const PauseActionCard = ({sec, uuid, drag, changesMade}:{sec:string, uuid:string, drag?:any, changesMade:()=>void}) => {
	const [editHover, setEditHover] = useState(false)
	const [deleteHover, setDeleteHover] = useState(false);
	const dispatch = useDispatch();
	return (
		<div className={styles.card} draggable onDragEnd={drag?.handlesort}  onDragEnter={()=>{drag?.dragEnter(drag)}} onDragStart={()=>{drag?.dragStart(drag)}}> 
			<p>
				{drag && <MoveUpDown />}
				<PauseIcon />
				<span>Pause</span>
			</p>
			<p>
				<span className={styles.extension}>{sec} sec.</span>
				{uuid &&
				<>
					<span className={styles.actionButton} onClick={()=>{changesMade(); dispatch(setShowPauseDialogue({uuid:`${uuid}`, show:true, secondsValue:`${sec}`}))}} onMouseOver={() => {setEditHover(true);}} onMouseOut={() => {setEditHover(false);}}><EditIcon color={editHover?"primary-default" : "icon-primary"}/></span>
					<span className={styles.actionButton} onClick={()=>{changesMade(); dispatch(removeSidecarConfigNewTempActionList(uuid))}} onMouseOver={() => {setDeleteHover(true);}} onMouseOut={() => {setDeleteHover(false);}}><DeleteIcon color={deleteHover?"support-danger-default" : "icon-primary"} /></span>
				</>}	
			</p>
		</div>
	);
};

export default PauseActionCard;
